const HttpJsonJs = () => {
  return (
    <div style={{ textAlign: 'left' }}>
      <h1>JavaScript: HTTP Requests & JSON</h1>
      <p>The code on the right sends an HTTP GET request to an API service called api.quinnandmurray.com</p>
      <p>When the response from the API request returns successfully, it calls a function called "handleResponse."</p>
      <p>Modify the function "handleResponse" to retrieve and print the text of each error message that is returned in the response.</p>
    </div>
  )
}

export default HttpJsonJs;